import { gql } from '@apollo/client'

export const AUDIT_QUESTION_FRAGMENT = gql`
  fragment AuditQuestion on AuditQuestion {
    id
    question
    category
    pointWorth
    group
    active
    hideInApp
  }
`
